<div class="row column-selector">
  @if (!availableColumns || !selectedColumns) {
    <div class="stage">
      <div class="dot-flashing"></div>
    </div>
  } @else {
    <div class="draggable-list-container">
      <h2>Selected Columns</h2>
      <option-list-search
        [placeholder]="'Search columns'"
        (inputChanged)="selectedColumnFilterValue=$event"
        (inputCleared)="selectedColumnFilterValue=''"
      ></option-list-search>
      <div
        id="selectedList"
        #selectedList="cdkDropList"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="[availableList]"
        [cdkDropListData]="selectedColumns"
        cdkDropList
        class="draggable-list">
        @for (column of selectedColumns | filterByValue: columnFilter : selectedColumnFilterValue; track column.id) {
          <div
            cdkDrag [cdkDragData]="column" class="draggable-list-item">
          <div [ngStyle]="{'font-weight':column.format?.bold? 'bold' : '',
              'font-style':column.format?.italic? 'italic' : '',
              'font-size': column.format?.size ? column.format.size + '%' : '100%'}"
              class="column-name" cdkDragHandle
              [dblClickCopy]="modelDict[column.id]?.attributes.name">
              <div>{{modelDict[column.id]?.attributes.name | upperfirst}}</div>
            </div>
            <div class="row min-height">
              @if (isDropDownList(column.id)) {
                <select-many-filter class="select-filter-inline"
                  [options]="getDropDownListOptions(column.id)"
                  [modelValue]="selectedFilters[column.id]"
                  [placeholder]="'Select filter'"
                  [listType]="'filters'"
                  [classes]="'fill'"
                  (constant_changed)="onFiltersChange($event, column.id)"
                ></select-many-filter>
              }
              <!--          @if (isDateTime(column.id)) {-->
              <!--            <select-many-filter class="select-filter-inline"-->
              <!--                [options]="getDropDownListOptions(column.id)"-->
              <!--                [modelValue]="selectedFilters[column.id]"-->
              <!--                [placeholder]="'Select filter'"-->
              <!--                [listType]="'filters'"-->
              <!--                (constant_changed)="onFiltersChange($event, column.id)"-->
            <!--              ></select-many-filter>-->
          <!--          }-->
          @if (isText(column.id)) {
            <input class="text-filters"
              [ngModel]="selectedFilters[column.id]"
              matInput
              (ngModelChange)="onTextFiltersChange($event, column.id)"
              />
          }
          <div class="column-title">
            <input
              #aliasInput
              [ngModel]="toSnakeCase(column.title)"
              matInput
              placeholder="Alias"
              (ngModelChange)="column.title=$event;onAliasChange($event, column.id)"
              (keydown)="preventKeys($event)"
              [matTooltip]="isTextOverflowing(aliasInput) ? aliasValues[column.id] || toSnakeCase(column.title) : ''"
              name="Alias" style="width: auto" maxlength="30"/>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div class="column select-remove-buttons">
  @for (btn of selectRemoveButtons; track btn) {
    <button mat-raised-button color="primary">
      <i (click)="moveColumns(btn.type)"
        [class]="'fas fa-angle-double-' + btn.iconDirection"
        [matTooltip]="btn.type + ' all available columns' | upperfirst"
      class="action-icon"></i>
    </button>
  }
</div>
<div class="draggable-list-container">
  <h2>Available Columns</h2>
  <option-list-search
    [placeholder]="'Search columns'"
    (inputChanged)="availableColumnFilterValue=$event"
    (inputCleared)="availableColumnFilterValue=''"
  ></option-list-search>
  <div
    id="availableList"
    #availableList="cdkDropList"
    (cdkDropListDropped)="drop($event)"
    [cdkDropListConnectedTo]="[selectedList]"
    [cdkDropListData]="availableColumns"
    cdkDropList
    class="draggable-list">
    @for (column of availableColumns | filterByValue: columnFilter : availableColumnFilterValue; track column.id) {
      <div
        cdkDrag
        [cdkDragData]="column"
        class="draggable-list-item"
        [dblClickCopy]="modelDict[column.id]?.attributes.name">
        <span
            [matTooltip]="modelDict[column.id]?.attributes?.description || modelDict[column.id]?.attributes?.name"
            [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"
            [matTooltipDisabled]="!modelDict[column.id]?.attributes?.description && !modelDict[column.id]?.attributes?.name">
            {{modelDict[column.id]?.attributes.name | upperfirst}}
          </span>
        @if (modelDict[column.id]?.attributes.is_calculation) {
          <span class="column-type">
            (calculation)
          </span>
        }
        @if (modelDict[column.id]?.attributes.is_drop_down_list) {
          <span class="column-type">
            (dropdown)
          </span>
        }
      </div>
    }
  </div>
</div>
}
</div>
